import { Button, Empty, Layout, List, LoadingIndicator, Menu, Sidebar, TitlePortal, UserMenu, useCreate, useGetIdentity, useGetOne, useNotify, usePermissions, useSidebarState, useStore } from "react-admin";
import { ReactQueryDevtools } from 'react-query/devtools'
import { AppBar } from 'react-admin';
import Box from '@mui/material/Box';
import BookIcon from '@mui/icons-material/Book';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import PeopleIcon from '@mui/icons-material/People';
import LabelIcon from '@mui/icons-material/Label';
import { BsBack, BsFillGearFill } from "react-icons/bs";
import EmailSettingsLogo from "../assets/images/mailLogo.png";
import logReport from "../assets/images/logReport.png";
import dashboardLogo from "../assets/images/dashboard.png";

import userSetupLogo from "../assets/images/userSetupLogo.png";
// import AdverseLogo from "../assets/images/Frame (6).png";
import ManageUserLogo from "../assets/images/ManageUser.png";
import GeographicalsettingLogo from "../assets/images/Vector (2).png";
import {
  FaCircle,
  FaUpload,
} from "react-icons/fa";
import { BiArchive, BiArrowBack, BiExit, BiUpload } from "react-icons/bi";
import SwitchSubscriber from "./Ats/SwitchSubscriber";


import DocuverusLogo from "../assets/images/docuverus_logo.png";
import {
  Dashboard,
  DashboardCustomizeSharp,
  DashboardOutlined,
  Message,
  Square,
} from "@mui/icons-material";
import { useParams } from "react-router";
import { JSONTree } from "react-json-tree";
import React, { useEffect } from "react";
import { SOFTWARE_VERSION, typesofUsers } from "../config";
import { ImUpload2 } from "react-icons/im";
import ListSubheader from "@mui/material/ListSubheader";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import SendIcon from "@mui/icons-material/Send";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";
import { useLocation } from "react-router-dom";
import MuiList from "@mui/material/List";
import { IoMdSettings } from "react-icons/io";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
// import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { RiListSettingsLine } from "react-icons/ri";
import ArticleIcon from '@mui/icons-material/Article';
import DnsIcon from '@mui/icons-material/Dns';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import LockPersonOutlinedIcon from '@mui/icons-material/LockPersonOutlined';
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import { Button as MuiButton, useMediaQuery, useTheme, Theme } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate } from "react-router-dom";
import { styled, alpha } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import GoogleTranslate from "./common/GoogleTranslate";
import { useOpenPanel } from "../hooks/useOpenPanel";
import { BsShieldFillCheck } from "react-icons/bs";
import { color } from "html2canvas/dist/types/css/types/color";
import AdverseLogo from "../assets/images/Frame (6).png";
import ApplicationLogo from '../assets/images/Frame (12).png';
import { checkModuleAccess, isSuperAdmin } from "../Functions/permissions";
import { MAIN_APP_URL } from "../config";
import AdminNotificationLogo from "../assets/images/Frame (7).png";
import AdminResourceLogo from "../assets/images/Frame (11).png";
declare global {
  interface Window {
    google: any;
  }
}

const submenuIconSx = { fontSize: 16, color: "#909090" };
const parentMenuIconSx = { fontSize: 16, color: "#909090" };




const MyUserMenu = () => {
  const [create, { isSuccess, data }] = useCreate();
  useEffect(() => {
    if (data) {
      localStorage.removeItem("auth");
      window.location.replace(MAIN_APP_URL);
    }
  }, [data]);

  return (
    <UserMenu>
      <MuiButton
        sx={{ width: 140 }}
        startIcon={<BiExit />}
        onClick={() => {
          create("logout");
        }}
        size="small"
      >
        Logout
      </MuiButton>
    </UserMenu>
  );
};

export const MyAppBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [switchSubscriberObj] = useStore("switchSubscriberName");
  const { data } = useGetIdentity();
  const openpanel = useOpenPanel();
  useEffect(() => {
    if (data?.userid) {
      openpanel.identify({
        profileId: String(data.userid),
        email: data.username,
        firstName: data.fullName,
        properties: { role: data.userrole },
      });
      setTimeout(() => {openpanel.ready()}, 5000);
    }
  }, [data?.userid]);
  const subscriberView: boolean = data?.subscriberView;
  const isDocuploadRoute = location.pathname.startsWith("/admin");
  const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  }));

  const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    width: '100%',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      [theme.breakpoints.up('sm')]: {
        width: '12ch',
        '&:focus': {
          width: '20ch',
        },
      },
    },
  }));

  const switchSubscriberStatus = localStorage.getItem("RaStore.switchSubscriber") ? localStorage.getItem("RaStore.switchSubscriber") : "false";
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      navigate("/Ats/getglobalsearch", {
        state: { search: e.target.value },
      });
    }
  };
  return (
    <AppBar userMenu={<MyUserMenu />} color="primary" toolbar={<>
      {(data?.userrole.toLowerCase()!=typesofUsers.admin.toLowerCase() && data?.userrole.toLowerCase()!=typesofUsers.subscriberAdmin.toLowerCase()  && switchSubscriberStatus == 'false') && <Search>
        <SearchIconWrapper>
          <SearchIcon />
        </SearchIconWrapper>
        <StyledInputBase
          onKeyDown={handleKeyDown}
          placeholder="Global Search"
          inputProps={{ 'aria-label': 'search' }}
        />
      </Search>}
       <SwitchSubscriber />
      {!isDocuploadRoute && <GoogleTranslate />}
      <LoadingIndicator />
    </>
    }>

      <img src={DocuverusLogo} alt="Docuverus" />
      &nbsp;
      {!subscriberView && <strong> {switchSubscriberObj?.label}</strong>}
      <Box flex="1" />
      <Box flex="1" />
    </AppBar>
  );
};

const DOC_ANALYSIS_OUTLINE_CLASS = "doc-analysis-outline-active";
// Open ATS drawer width from the .RaMenu-open paper rule in App.css.
const OPEN_SIDEBAR_WIDTH = 293;

const useDocAnalysisOutlineActive = () => {
  const [active, setActive] = React.useState(
    () => document.body.classList.contains(DOC_ANALYSIS_OUTLINE_CLASS)
  );

  useEffect(() => {
    const update = () => {
      const next = document.body.classList.contains(DOC_ANALYSIS_OUTLINE_CLASS);
      setActive((current) => (current === next ? current : next));
    };
    update();
    const observer = new MutationObserver(update);
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  return active;
};

export const MyMenu = (props) => {
  const [sidebarOpen] = useSidebarState();
  const outlineActive = useDocAnalysisOutlineActive();
  const showOutlineMenu = !sidebarOpen && outlineActive;
  const [open, setOpen] = React.useState(false);
  const [openSettngs, setOpenSettngs] = useStore('openSettings', false);
  const [openMgt, setopenMgt] = useStore('openMgt', false);
  const [userPermission, setUserPermission] = useStore('userPermission', false);
  const [openTerms, setOpenTerms] = useStore('openTermsCondtions', false);
  const [aopenMgt, setaopenMgt] = useStore('aopenMgt', false);
  const [adminUserPermission, setAdminUserPermission] = useStore('adminUserPermission', false);
  const [openIntegrationSettings, setOpenIntegrationSettings] = React.useState(false);
  const { permissions } = usePermissions();
  const handleClick = () => {
    setOpen(!open);
  };
  const settingsonClickHandler = () => {
    setOpenSettngs(!openSettngs);
  };
  const mgtonClickHandler = () => {
    setopenMgt(!openMgt);
  };
  const permissiononClickHandler = () => {
    setUserPermission(!userPermission);
  };
  const integrationSettingsonClickHandler = () => {
    setOpenIntegrationSettings(!openIntegrationSettings);
  };
  const location = useLocation();
  const { data } = useGetIdentity();
  const [switchSubscriberObj, setSwitchSubscriberObj] = useStore('switchSubscriberName', { value: '', label: '', companyType: '' });
  const switchSubscriber = localStorage.getItem("RaStore.switchSubscriber")
  const subscriberView: boolean = data?.subscriberView;

  const [create] = useCreate();
  const notify = useNotify();
  useEffect(() => {
    if (window.location.pathname.split("/")[1] == "ml") setOpen(true);
  }, [window.location]);

  // get company type Data
  const { data: subscriberThirdPartyMenu } = useGetOne(
    "subscriber-third-party-menu",
    {
      id: switchSubscriberObj?.value,
    },
    {
      refetchOnWindowFocus: false,
      enabled: switchSubscriberObj?.value ? true : false,
    }
  );
  return (
    <Menu
      {...props}
      className={[props.className, showOutlineMenu ? "ats-doc-outline-menu" : ""]
        .filter(Boolean)
        .join(" ")}
      style={
        showOutlineMenu
          ? { ...(props.style || {}), width: OPEN_SIDEBAR_WIDTH }
          : props.style
      }
    >
      <div
        id="doc-analysis-sidebar-outline-root"
        className="doc-analysis-sidebar-outline-root"
      />
      <div className={`standard-sidebar-menu${sidebarOpen ? "" : " ats-sidebar-closed"}`}>

      {!(switchSubscriber === "true") && isSuperAdmin(checkModuleAccess(permissions, "Dashboard", ""), data?.userrole)
        ? (location.pathname.split('/')[1] == 'ml')
          ? <Menu.Item to={'/ats'} primaryText="Dashboard" leftIcon={<img src={dashboardLogo} style={{ color: "#909090", fontSize: "10.7px" }} alt="dashboard" />} />
          : <Menu.DashboardItem leftIcon={<img src={dashboardLogo} style={{ color: "#909090", fontSize: "10.7px" }} alt="dashboard" />} />
        : null}

      {(switchSubscriber === "true" && subscriberView) && isSuperAdmin(checkModuleAccess(permissions, "Dashboard", ""), data?.userrole)
        ? (location.pathname.split('/')[1] == 'ml')
          ? <Menu.Item to={'/ats'} primaryText="Dashboard" leftIcon={<img src={dashboardLogo} style={{ color: "#909090", fontSize: "10.7px" }} alt="dashboard" />} />
          : <Menu.DashboardItem leftIcon={<img src={dashboardLogo} style={{ color: "#909090", fontSize: "10.7px" }} alt="dashboard" />} />
        : null}

      {(switchSubscriber === "true" && !subscriberView) && isSuperAdmin(checkModuleAccess(permissions, "Dashboard", ""), data?.userrole) && <Menu.Item to={'/ats/subscriber/inbox/' + switchSubscriberObj?.value} primaryText="Dashboard" leftIcon={<img src={dashboardLogo} style={{ color: "#909090", fontSize: "10.7px" }} alt="dashboard" />} />}

      {(subscriberView || (switchSubscriber === "true")) && isSuperAdmin(checkModuleAccess(permissions, "Settings", ""), data?.userrole) && (isSuperAdmin(checkModuleAccess(permissions, "Settings", "Archived"), data?.userrole) || isSuperAdmin(checkModuleAccess(permissions, "Settings", "Archive Docupload"), data?.userrole) || isSuperAdmin(checkModuleAccess(permissions, "Settings", "Archive Guestcard"), data?.userrole)) &&
        <Menu.Item to={"/Ats/subscriber/getarchivedcancelled/" + (switchSubscriberObj?.value || data?.subscriberid)} primaryText="Archived / Cancelled" leftIcon={<BiArchive />} />}
      {(subscriberView || (switchSubscriber === "true")) && <Menu.Item to={"/Ats/subscriberresource/"} primaryText="Help Resources" leftIcon={<img src={AdminResourceLogo} style={{ color: "#909090" }} alt="Resource" />} />}
      {(!subscriberView && !(switchSubscriber === "true")) && <Menu.Item to="/Ats/SubscriberUsageList" primaryText="Subscriber Usage List" leftIcon={<PeopleIcon style={{ fontSize: "14.7px", color: "#909090" }} />} />}
      {(!subscriberView && !(switchSubscriber === "true")) && <Menu.Item to="/Ats/getloginactivitylogs" primaryText="Log report " leftIcon={<img src={logReport} style={{ color: "#909090", fontSize: "10.7px" }} alt="log report" />} />}
      {(!subscriberView && !(switchSubscriber === "true")) && <Menu.Item to="/Ats/getEmailSettings" primaryText="Email Settings " leftIcon={<img src={EmailSettingsLogo} style={{ color: "#909090" }} alt="email settings" />} />}
      {/* {(!subscriberView && !(switchSubscriber === "true")) && <Menu.Item to="/ats/termsandconditions" primaryText="Terms and Conditions" leftIcon={<BsShieldFillCheck />} />} */}

      {!(switchSubscriber === "true") && data?.userrole == "Docuverus Super Admin" && checkModuleAccess(permissions, "Terms & Conditions", "") && <MuiList dense disablePadding>
        <Menu.Item to="#" onClick={(e) => { e.preventDefault(); setOpenTerms(!openTerms) }} primaryText="Terms and Conditions" style={{ fontSize: '13.7px' }} leftIcon={<DescriptionOutlinedIcon sx={parentMenuIconSx} />} />
        {checkModuleAccess(permissions, "Terms & Conditions", "") && <Collapse sx={{ background: "#2cc0e414" }} in={openTerms} timeout="auto" unmountOnExit>
          <MuiList component="div" disablePadding sx={{ marginLeft: "16px" }}>
            {checkModuleAccess(permissions, "Terms & Conditions", "Applicant") && <Menu.Item to="/ats/termsandconditions_applicant" primaryText="Applicant" leftIcon={<PersonOutlineIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
            {checkModuleAccess(permissions, "Terms & Conditions", "Subscriber User") && <Menu.Item to="/ats/termsandconditions_subscriber" primaryText="Subscriber User" leftIcon={<GroupsOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
            {checkModuleAccess(permissions, "Terms & Conditions", "Landlord/Third Party") && <Menu.Item to="/ats/termsandconditions_landloard" primaryText="Landloard/Third Party" leftIcon={<HomeWorkOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
            {checkModuleAccess(permissions, "Terms & Conditions", "Data Privacy") && <Menu.Item to="/ats/termsandconditions_privacy" primaryText="Data Privacy" leftIcon={<LockOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
            {checkModuleAccess(permissions, "Terms & Conditions", "Terms Of Use") && <Menu.Item to="/ats/termsandconditions_termsofuse" primaryText="Terms of Use" leftIcon={<GavelOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
            </MuiList>
        </Collapse>}
      </MuiList>}

      {!(switchSubscriber === "true") && data?.userrole == "Docuverus Super Admin" && checkModuleAccess(permissions, "Management Report", "") && <MuiList dense disablePadding>
        <Menu.Item to="#" onClick={(e) => { e.preventDefault(); setaopenMgt(!aopenMgt) }} primaryText="Management Reports" style={{ fontSize: '13.7px' }} leftIcon={<BarChartOutlinedIcon sx={parentMenuIconSx} />} />
        {checkModuleAccess(permissions, "Management Report", "") && <Collapse sx={{ background: "#2cc0e414" }} in={aopenMgt} timeout="auto" unmountOnExit>
          <MuiList component="div" disablePadding sx={{ marginLeft: "16px" }}>
            {checkModuleAccess(permissions, "Management Report", "Admin Revenue") && <Menu.Item to="/ats/adminrevenue" primaryText="Admin Revenue" leftIcon={<PaymentsOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
            {checkModuleAccess(permissions, "Management Report", "Lead Management") && <Menu.Item to="/ats/adminlead" primaryText="Lead Management" leftIcon={<LeaderboardOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
            <Menu.Item to="/ats/adminplaidmanagement" primaryText="Direct Linking Report" leftIcon={<LinkOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />
            {checkModuleAccess(permissions, "Management Report", "Screening Revenue ") && <Menu.Item to="/ats/adminscreen" primaryText="Screening Revenue" leftIcon={<FactCheckOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
            <Menu.Item to="/ats/adminverification" primaryText="Verification Report" leftIcon={<VerifiedOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />
            </MuiList>
        </Collapse>}
      </MuiList>}


      {!(switchSubscriber === "true") && data?.userrole == "Docuverus Super Admin" && <MuiList dense disablePadding>
        <Menu.Item to={'#'} onClick={(e) => { e.preventDefault(); setAdminUserPermission(!adminUserPermission) }} primaryText="Permissions" style={{ fontSize: '13.7px' }} leftIcon={<LockPersonOutlinedIcon sx={parentMenuIconSx} />} />
        <Collapse sx={{ background: "#2cc0e414" }} in={adminUserPermission} timeout="auto" unmountOnExit>
          <MuiList component="div" disablePadding sx={{ marginLeft: "16px" }}>
            <Menu.Item to="/ats/AdminPermissions" primaryText="Admin Permissions" leftIcon={<AdminPanelSettingsOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />
            <Menu.Item to="/ats/thirdParty" primaryText="Landlord/Third Party Permissions" leftIcon={<HomeWorkOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px', marginRight: 0 }} />
          </MuiList>
        </Collapse>
      </MuiList>}

      {!(switchSubscriber === "true") && data?.userrole == "Docuverus Super Admin" && checkModuleAccess(permissions, "ML Prediction", "") && <MuiList dense disablePadding>
        <Menu.Item to={'/ml'} onClick={(e) => { e.preventDefault(); handleClick() }} primaryText="ML Prediction" style={{ fontSize: '13.7px' }} leftIcon={<PsychologyOutlinedIcon sx={parentMenuIconSx} />} />
        {checkModuleAccess(permissions, "ML Prediction", "") && <Collapse sx={{ background: "#2cc0e414" }} in={open} timeout="auto" unmountOnExit>
          <MuiList component="div" disablePadding sx={{ marginLeft: "16px" }}>
            {checkModuleAccess(permissions, "ML Prediction", "Predict Paystub") && <Menu.Item to="/ml/predictps" primaryText="Predict Paystub" leftIcon={<ReceiptLongOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
            {checkModuleAccess(permissions, "ML Prediction", "Predict Statement") && <Menu.Item to="/ml/predictbs" primaryText="Predict Bank" leftIcon={<AccountBalanceOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
            {checkModuleAccess(permissions, "ML Prediction", "List & Retrain") && <Menu.Item to="/ml/mlclassdetails" primaryText="List & Retrain" leftIcon={<ListAltOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
            {checkModuleAccess(permissions, "ML Prediction", "Retrain Logs") && <Menu.Item to="/ml/getclassretrainlogs" primaryText="Retrain Logs" leftIcon={<HistoryOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
            {checkModuleAccess(permissions, "ML Prediction", "Flagged Documents") && <Menu.Item to="/ml/getFlaggedDocuments" primaryText="Flagged Documents" leftIcon={<FlagOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
            {checkModuleAccess(permissions, "ML Prediction", "Flagged SOCR Data") && <Menu.Item to="/ml/getFlaggedSOCRData" primaryText="Flagged SOCR Data" leftIcon={<TableChartOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
          </MuiList>
        </Collapse>}
      </MuiList>}

      {((subscriberView || (switchSubscriber === "true"))
        // && (data?.userrole !== "Agent" && data?.userrole !== "Manager")
      ) && <MuiList dense disablePadding>
          {isSuperAdmin(checkModuleAccess(permissions, "Settings", ""), data?.userrole) && <Menu.Item to={'/ats/settings'} onClick={(e) => { e.preventDefault(); settingsonClickHandler() }} primaryText="Settings" style={{ fontSize: '13.7px' }} leftIcon={openSettngs ? <ExpandLess /> : <ExpandMore />} />}
          {isSuperAdmin(checkModuleAccess(permissions, "Settings", ""), data?.userrole) && <Collapse sx={{ background: "#2cc0e414" }} in={openSettngs} timeout="auto" unmountOnExit>
            <MuiList component="div" disablePadding sx={{ marginLeft: "10px" }}>
              {/* {data?.userrole === "Docuverus Super Admin" && */}
              {isSuperAdmin(checkModuleAccess(permissions, "Settings", "Email Settings"), data?.userrole) && <Menu.Item to={"/ats/settings/emailSettings"} primaryText="Email Settings" leftIcon={<MailOutlineIcon sx={{ fontSize: 11 }} />} style={{ fontSize: '10.7px' }} />}
              {data?.userrole === typesofUsers?.docuverusAdmin && checkModuleAccess(permissions, "Other Permissions", "View Users")
                ? <Menu.Item to={"/ats/settings/usersetup"} primaryText="User Setup" leftIcon={<img src={ManageUserLogo} style={{ color: "gray" }} alt="email settings" />} style={{ fontSize: '10.7px' }} />
                : data?.userrole != typesofUsers?.docuverusAdmin && isSuperAdmin(checkModuleAccess(permissions, "Settings", "User Setup"), data?.userrole)
                  ? <Menu.Item to={"/ats/settings/usersetup"} primaryText="User Setup" leftIcon={<img src={ManageUserLogo} style={{ color: "gray" }} alt="email settings" />} style={{ fontSize: '10.7px' }} />
                  : ""}
              {/* } */}

              {/* for permissions */}
              {((subscriberView || (switchSubscriber === "true"))) &&
                <MuiList dense disablePadding>
                  {isSuperAdmin(checkModuleAccess(permissions, "Permissions", ""), data?.userrole) && <Menu.Item to={'/ats/settings/permission'} onClick={(e) => { e.preventDefault(); permissiononClickHandler() }} primaryText="Permissions " style={{ fontSize: '10.7px' }} leftIcon={userPermission ? <ExpandLess /> : <ExpandMore />} />}
                  {isSuperAdmin(checkModuleAccess(permissions, "Permissions", ""), data?.userrole) && <Collapse sx={{ background: "#2cc0e414" }} in={userPermission} timeout="auto" unmountOnExit>
                    <MuiList component="div" disablePadding sx={{ marginLeft: "10px" }}>
                      {/* {data?.userrole === "Docuverus Super Admin" && */}
                      {isSuperAdmin(checkModuleAccess(permissions, "Permissions", "Subscriber Users"), data?.userrole) && <Menu.Item to={"/ats/settings/permission/userPermission"} primaryText="User Permissions" leftIcon={<ManageAccountsOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
                      {isSuperAdmin(checkModuleAccess(permissions, "Permissions", "Third Party Users"), data?.userrole) && <Menu.Item to={"/ats/settings/permission/ThirdPartyPermission"} primaryText=" Landlord/Third Party Permissions" leftIcon={<HomeWorkOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
                    </MuiList>
                  </Collapse>}
                </MuiList>}
              {/* } */}
              {/* {data?.userrole === "Docuverus Super Admin" && */}
              {isSuperAdmin(checkModuleAccess(permissions, "Settings", "Hierarchy Level"), data?.userrole) && <Menu.Item to={"/ats/settings/hierarchyLevel"} primaryText="Hierarchy Level" leftIcon={<AccountTreeIcon sx={{ fontSize: 11 }} />} style={{ fontSize: '10.7px' }} />}
              {<Menu.Item to={"/ats/settings/predefinedMessage"} primaryText="Predefined Messages" leftIcon={<Message sx={{ fontSize: 11 }} />} style={{ fontSize: '10.7px' }} />}
             
              {/* } */}

              {
                //  data?.userrole === "Docuverus Super Admin" && 
                isSuperAdmin(checkModuleAccess(permissions, "Settings", "Adverse Letters"), data?.userrole) &&
                <Menu.Item to={"/ats/settings/getadverseletter"} primaryText="Adverse Letter" leftIcon={<img src={AdverseLogo} style={{ color: "gray" }} alt="email settings" />} style={{ fontSize: '10.7px' }} />
              }
              {isSuperAdmin(checkModuleAccess(permissions, "Settings", "Application Profile"), data?.userrole) && <Menu.Item to={"/ats/settings/applicationProfile"} primaryText="Application Profile" leftIcon={<img src={ApplicationLogo} style={{ color: "gray" }} alt="Application Profile" />} style={{ fontSize: '10.7px' }} />}
              {
                //  data?.userrole === "Docuverus Super Admin" && 

                ((switchSubscriberObj?.companyType === "Real Estate" || data?.subscribertype === "Real Estate") &&
                  isSuperAdmin(checkModuleAccess(permissions, "Settings", "Confidentiality Log"), data?.userrole)) &&
                <Menu.Item to={"/ats/settings/getconfidentialitylogs"} primaryText="Confidentiality Log" leftIcon={<VisibilityOffOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />
              }
              {/* {data?.userrole === "Docuverus Super Admin" && */}
              {isSuperAdmin(checkModuleAccess(permissions, "Settings", "Invitation Logs"), data?.userrole) && <Menu.Item to={"/ats/settings/getinvitationlogs"} primaryText="Invitation Log" leftIcon={<MarkEmailReadOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
              {/* } */}
              {/* <Menu.Item style={{ fontSize: "10.7px" }} to="/ats/settings/termsandconditions" primaryText="Terms and Conditions" leftIcon={<BsShieldFillCheck />} /> */}
              {/* {switchSubscriberObj?.companyType === "Property Management" && ( */}
              {isSuperAdmin(checkModuleAccess(permissions, "Settings", "Terms & Conditions"), data?.userrole) && <Menu.Item style={{ fontSize: "10.7px" }} to="/ats/settings/termsandconditions" primaryText="Terms and Conditions" leftIcon={<BsShieldFillCheck />} />}

              {(switchSubscriberObj?.companyType === "Property Management" || data?.subscribertype === "Property Management") && data?.userrole === "Docuverus Admin" && isSuperAdmin(checkModuleAccess(permissions, "Other Permissions", "View Properties/Offices"), data?.userrole) ? (
                <Menu.Item
                  to={"/ats/settings/propertySetup"}
                  primaryText="Property Setup"
                  leftIcon={<MapsHomeWorkIcon sx={{ fontSize: 11 }} />}
                  style={{ fontSize: "10.7px" }}
                />
              ) : (switchSubscriberObj?.companyType === "Property Management" || data?.subscribertype === "Property Management") && data?.userrole != "Docuverus Admin" && isSuperAdmin(checkModuleAccess(permissions, "Settings", "Property Setup"), data?.userrole) ? (
                <Menu.Item
                  to={"/ats/settings/propertySetup"}
                  primaryText="Property Setup"
                  leftIcon={<MapsHomeWorkIcon sx={{ fontSize: 11 }} />}
                  style={{ fontSize: "10.7px" }}
                />
              ) : ""}
              {(switchSubscriberObj?.companyType === "Real Estate" || data?.subscribertype === "Real Estate") && data?.userrole === "Docuverus Admin" && isSuperAdmin(checkModuleAccess(permissions, "Other Permissions", "View Properties/Offices"), data?.userrole) ? (
                <Menu.Item
                  to={"/ats/settings/officeSetup"}
                  primaryText="Office Setup"
                  leftIcon={<MapsHomeWorkIcon sx={{ fontSize: 11 }} />}
                  style={{ fontSize: "10.7px" }}
                />
              ) : (switchSubscriberObj?.companyType === "Real Estate" || data?.subscribertype === "Real Estate") && data?.userrole != "Docuverus Admin" && isSuperAdmin(checkModuleAccess(permissions, "Settings", "Office Setup"), data?.userrole) ? (
                <Menu.Item
                  to={"/ats/settings/officeSetup"}
                  primaryText="Office Setup"
                  leftIcon={<MapsHomeWorkIcon sx={{ fontSize: 11 }} />}
                  style={{ fontSize: "10.7px" }}
                />
              ) : ""}
              
              {subscriberThirdPartyMenu?.data &&
                subscriberThirdPartyMenu?.data?.length > 0 && (
                  <>
                    <Menu.Item to={'/ats/settings/integrationSettings'} onClick={(e) => { e.preventDefault(); integrationSettingsonClickHandler() }} primaryText="Integration Settings" style={{ fontSize: '13.7px' }} leftIcon={openIntegrationSettings ? <ExpandLess /> : <ExpandMore />} />
                    <Collapse
                      sx={{ background: "#2cc0e414" }}
                      in={openIntegrationSettings}
                      timeout="auto"
                      unmountOnExit
                    >
                      <MuiList component="div" disablePadding sx={{ marginLeft: "10px" }}>
                        {subscriberThirdPartyMenu?.data &&
                          subscriberThirdPartyMenu?.data?.length > 0 &&
                          subscriberThirdPartyMenu?.data?.map((menus) => (
                            <Menu.Item
                              to={`/ats/settings/integrationSettings/${menus?.appName}`}
                              primaryText={menus?.appName}
                              leftIcon={<DnsIcon sx={{ fontSize: 11 }} />}
                              style={{ fontSize: "10.7px" }}
                              key={menus?.appID}
                            />
                          ))}
                      </MuiList>
                    </Collapse>
                  </>
                )}
            </MuiList>
          </Collapse>}
        </MuiList>}

      {((subscriberView || (switchSubscriber === "true"))
        //  && (data?.userrole !== "Agent" && data?.userrole !== "Manager")
      ) &&
        <MuiList dense disablePadding>
          {isSuperAdmin(checkModuleAccess(permissions, "Management Report", ""), data?.userrole) && <Menu.Item to={'/ats/managementreport'} onClick={(e) => { e.preventDefault(); mgtonClickHandler() }} primaryText="Management Reports" style={{ fontSize: '13.7px' }} leftIcon={openMgt ? <ExpandLess /> : <ExpandMore />} />}
          {isSuperAdmin(checkModuleAccess(permissions, "Management Report", ""), data?.userrole) && <Collapse sx={{ background: "#2cc0e414" }} in={openMgt} timeout="auto" unmountOnExit>
            <MuiList component="div" disablePadding sx={{ marginLeft: "10px" }}>
              {/* {data?.userrole === "Docuverus Super Admin" && */}
              {isSuperAdmin(checkModuleAccess(permissions, "Management Report", "Lead Management"), data?.userrole) && <Menu.Item to={"/ats/managementreport/getleadmanagementreport"} primaryText="Lead Management" leftIcon={<LeaderboardOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
              {/* } */}

              {isSuperAdmin(checkModuleAccess(permissions, "Management Report", "Revenue Mgmt"), data?.userrole) && <Menu.Item to={"/ats/managementreport/getrevenuemanagementreport"} primaryText="Revenue Management" leftIcon={<PaymentsOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
            


              {isSuperAdmin(checkModuleAccess(permissions, "Management Report", "Doc Upload Report"), data?.userrole) && <Menu.Item to={"/ats/managementreport/getdocuploadmanagementreport"} primaryText="Docupload Management" leftIcon={<UploadFileOutlinedIcon sx={submenuIconSx} />} style={{ fontSize: '10.7px' }} />}
              {/* <Menu.Item to={"/ats/managementreport/ScheduleReport"} primaryText="Schedule Report" leftIcon={<img src={Revenuemgt} style={{ fontSize: 11 }} />} style={{ fontSize: '10.7px' }} /> */}
            </MuiList>
          </Collapse>}
        </MuiList>}

      {(!subscriberView && !(switchSubscriber === "true")) && <Menu.Item to={"/ats/geographicalsetting"} primaryText="Geographic Rule Setting" leftIcon={<img src={GeographicalsettingLogo} style={{ color: "gray" }} alt="Geographic Rule Setting" />} />}
      {(!subscriberView && !(switchSubscriber === "true")) && <Menu.Item to={"/ats/manageSubscribers"} primaryText="Manage Subscribers" leftIcon={<RiListSettingsLine />} />}

      {(!subscriberView && !(switchSubscriber === "true")) && (data?.userrole === typesofUsers?.docuverusSuperAdmin || checkModuleAccess(permissions, "Other Permissions", "View Users")) && <Menu.Item to={"/ats/manageUsers"} primaryText="Manage Users" leftIcon={<img src={ManageUserLogo} style={{ color: "gray" }} alt="Manage Users" />} />}
      {(!subscriberView && !(switchSubscriber === "true")) &&  <Menu.Item to={"/ats/predefinedmessage"} primaryText="Predefined Messages" leftIcon={<Message  sx={{ fontSize: 16,color: "gray" }} />} />}
      {(!subscriberView && !(switchSubscriber === "true")) && <Menu.Item to={"/ats/adminresource"} primaryText="Manage Help Resources" leftIcon={<img src={AdminResourceLogo} style={{ color: "gray" }} alt="Manage Help Resources" />} />}
      {(!subscriberView && !(switchSubscriber === "true")) && <Menu.Item to={"/ats/adminnotification"} primaryText="System Notifications" leftIcon={<img src={AdminNotificationLogo} style={{ color: "gray" }} alt="System Notifications" />} />}
      </div>
    </Menu>
  )
};

export const MySidebar = (props) => {
  const [open] = useSidebarState();
  const theme = useTheme<Theme>();
  const closedWidth =
    (theme as any).sidebar?.closedWidth ?? SIDEBAR_CLOSED_WIDTH;
  const outlineActive = useDocAnalysisOutlineActive();

  // The submission outline replaces the standard menu on document-analysis
  // pages. Keep the icon rail only while that menu is the visible sidebar.
  const lockIconRail = !open && !outlineActive;

  return (
    <Sidebar
      {...props}
      sx={{
        "& .RaSidebar-fixed": {
          backgroundColor: "#eeeeee",
          ...(lockIconRail
            ? {
                width: `${closedWidth}px !important`,
                maxWidth: `${closedWidth}px !important`,
                paddingLeft: "0 !important",
                paddingRight: "0 !important",
                overflowX: "hidden !important",
                overflowY: "auto !important",
                scrollbarWidth: "thin",
                boxSizing: "border-box",
              }
            : outlineActive && !open
              ? {
                  width: `${OPEN_SIDEBAR_WIDTH}px !important`,
                  maxWidth: `${OPEN_SIDEBAR_WIDTH}px !important`,
                  paddingLeft: "0 !important",
                  paddingRight: "0 !important",
                  overflowX: "hidden !important",
                  overflowY: "auto !important",
                }
              : {}),
        },
        ...(outlineActive && !open
          ? {
              "& .MuiPaper-root": {
                width: `${OPEN_SIDEBAR_WIDTH}px !important`,
              },
              "& .RaMenu-closed": {
                width: `${OPEN_SIDEBAR_WIDTH}px !important`,
              },
            }
          : {}),
        ...(lockIconRail
          ? {
              "& .RaSidebar-fixed::-webkit-scrollbar": {
                display: "block !important",
                width: "4px",
              },
            }
          : {}),
      }}
      // Keep the drawer's children mounted even while closed. On narrow
      // viewports react-admin renders a temporary (modal) Drawer that, by
      // default, does not mount its children until opened. The Doc Analysis
      // outline portals its menu into #doc-analysis-sidebar-outline-root, which
      // lives inside the sidebar; if that node isn't in the DOM when the portal
      // effect runs, the menu never renders and opening the hamburger shows an
      // empty white strip. keepMounted guarantees the portal target exists.
      ModalProps={{ keepMounted: true }}
    />
  );
};

// Fallback collapsed sidebar width, used only if the theme doesn't define one.
const SIDEBAR_CLOSED_WIDTH = 55;

// A slim handle docked to the collapsed sidebar's right edge, vertically
// centered. It only appears when the sidebar is minimized and its sole job is
// to expand it, so users don't have to scroll back up to the (hide-on-scroll)
// app bar hamburger. When the sidebar is open it's hidden.
export const SidebarEdgeToggle = () => {
  const [open, setOpen] = useSidebarState();
  const theme = useTheme<Theme>();
  const isSmall = useMediaQuery<Theme>((t) => t.breakpoints.down("sm"));
  const outlineActive = useDocAnalysisOutlineActive();

  if (open) return null;

  // On mobile the collapsed temporary Drawer is fully hidden, so dock the
  // handle to the screen edge. On a document-analysis page the outline keeps
  // the open drawer width, so the handle sits on that outer edge.
  const closedWidth =
    (theme as any).sidebar?.closedWidth ?? SIDEBAR_CLOSED_WIDTH;
  const left = isSmall ? 0 : outlineActive ? OPEN_SIDEBAR_WIDTH : closedWidth;

  return (
    <Box
      className="sidebar-edge-toggle"
      role="button"
      tabIndex={0}
      aria-label="Expand menu"
      title="Expand menu"
      onClick={() => setOpen(true)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setOpen(true);
        }
      }}
      style={{ left: `${left}px` }}
      sx={{
        position: "fixed",
        top: "50%",
        left: `${left}px`,
        transform: "translateY(-50%)",
        zIndex: (theme) => theme.zIndex.drawer + 2,
        width: 18,
        height: 56,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        backgroundColor: "#2DC3E8",
        color: "#fff",
        borderRadius: "0 8px 8px 0",
        boxShadow: 2,
        "&:hover": { backgroundColor: "#27b0d2" },
      }}
    >
      <ChevronRightIcon fontSize="small" />
    </Box>
  );
};

const MyLayout = (props: any) => {
  const theme = useTheme<Theme>();
  const closedWidth =
    (theme as any).sidebar?.closedWidth ?? SIDEBAR_CLOSED_WIDTH;

  return (
  <div style={{ ["--ats-sidebar-closed-width" as string]: `${closedWidth}px` } as React.CSSProperties}>

    <SidebarEdgeToggle />
    <Layout
      sx={{
        "& .RaLayout-appFrame": { marginTop: "50px" },
        "& .RaLayout-contentWithSidebar": { minWidth: 0 },
        "& .RaLayout-content": { minWidth: 0, width: "100%" },
        "& .RaLayout-content > div": { minWidth: 0, width: "100%", maxWidth: "100%" },
      }}
      {...props}
      appBar={MyAppBar}
      menu={MyMenu}
      sidebar={MySidebar}
     >
      <div style={{ minHeight: "85vh", width: "100%", minWidth: 0 }}> {props?.children}</div>

      <footer
        style={{
          backgroundColor: "#f8f9fa",
          padding: "10px",
          bottom: "0",
          display: "flex",
          justifyContent: "space-between", // Align content to the left and right edges
          alignItems: "center", // Vertically center content
          flexWrap: "wrap",
          gap: "8px 16px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", flex: "1 1 320px", minWidth: 0 }}>
          <p style={{ fontSize: "12px", margin: 0, overflowWrap: "anywhere" }}>
            Need help completing your application? Docuverus can be reached by
            phone at <b>856.886.8843</b> or by email at{" "}
            <b>support@docuverus.com</b>
          </p>
        </div>
        <div style={{ display: "flex", alignItems: "center", flex: "0 1 auto", minWidth: 0, marginLeft: "auto" }}>
          <p
            style={{
              fontSize: "12px",
              margin: 0,
              marginRight: "20px",
              textAlign: "right",
              overflowWrap: "anywhere",
            }}
          >
            © 2024 Docuverus (version{SOFTWARE_VERSION} )
          </p>
        </div>
      </footer>
    </Layout>


  </div>
  );
};

export default MyLayout;
